import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { TextInput } from "../Shared/Forms";
import { Spinner } from "../Shared";

import { configActions } from "./actions/configs.actions";
import { routeConstants } from "../../_constants";

export class ConfigForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getConfig();
  }

  componentWillUnmount() {
    this.props.resetConfig();
  }

  getConfig = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getConfig(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.configForm.reset();
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      data = {
        id: match.params.id,
        ...data
      };
    }
    this.props.addConfig(data);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const config = viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CONFIGS.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Configuration
                <small>{config && hasParams ? `: ${config.code}` : null}</small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="configForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                <TextInput
                  name="name"
                  value={config && hasParams ? config.name : null}
                  required
                  disabled={submitting || hasParams}
                  title="Configuration Name"
                />
                <TextInput
                  name="value"
                  value={config && hasParams ? config.value : null}
                  required
                  disabled={submitting}
                  title="Configuration value"
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { submitting, submitted, request, response, error } = state.addConfig;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewConfig;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addConfig: bindActionCreators(configActions.addConfig, dispatch),
    resetConfig: bindActionCreators(configActions.resetConfig, dispatch),
    getConfig: bindActionCreators(configActions.getConfig, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfigForm);
